import _ from 'lodash'
import api from '../../api/index'
import * as types from '../../types/index'

// 企业那边接口有改动的话，修改请求和对应参数即可
export default {
  state: {
    myInfo: {
      customerId: '',
      customerName: '',
      personIdentityCard: '',
      personMobile: '',
      isEditable: false
    },
    enterpriseInfo: {}
  },
  getters: {
    [types.GET_MY_INFO]: state => state.myInfo,
    [types.ENTERPRISE_INFO]: state => state.enterpriseInfo
  },
  actions: {
    [types.GET_PERSONAL_INFO] ({dispatch, commit}, params) {
      return api.getPersonalInfo({
        token: params.token,
        customerId: params.customerId
      }).then((res) => {
        const resData = res.data
        const result = resData.data
        if (Number(resData.code) === 0) {
          commit(types.SET_PERSONAL_INFO, {
            customerId: result.customerId,
            customerName: result.customerName,
            personIdentityCard: result.personIdentityCard,
            personMobile: result.mobile,
            isEditable: result.isEditable === '0'
          })
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '个人实名信息获取失败'
          })
        }
        return res
      })
    },
    [types.SAVE_PERSONAL_INFO] ({dispatch, commit}, params) {
      return api.savePersonalInfo({              //实名认证
        token: params.token,
        customerId: params.customerId,
        customerName: params.customerName,
        personIdentityCard: params.personIdentityCard
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          commit(types.SET_PERSONAL_INFO, {
            customerName: params.customerName,
            personIdentityCard: params.personIdentityCard,
            personMobile: params.personMobile
          })
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '个人信息保存失败'
          })
        }
        return res
      })
    },
    //获取初始化区域/城市信息
    [types.GET_BYCAT_KEY] ({dispatch, commit}, params) {
      return api.getByCatKey({
        catKey: params.catKey,
        parentId: params.parentId
      }).then((res) => {
        return res
      })
    },
    //获取初始化其他Select信息
    [types.GET_ALL_SELECT] ({dispatch, commit}, params) {
      return api.getallSelect().then((res) => {
        return res
      })
    },
    //获取初始化区域信息GETBYCATKEY
    //个人信息保存
    [types.SAVE_PERSONAL_INFO_All] ({dispatch, commit}, params) {
      return api.savePersonalInfoall({
          token: params.token,
          // personSex: params.personSex,
          // personBirthDate: params.personBirthDate,
          personEducation: params.personEducation,
          personCollege: params.personCollege,
          customerArea: params.customerArea,
          personCategory: params.personCategory,
          personCensusAddr: params.personCensusAddr,
          personMarital: params.personMarital,
          personFamily: params.personFamily,
          personExistChild: params.personExistChild,
          personHouse: params.personHouse,
          b: params.b,
          personDwellAddr: params.personDwellAddr,
          personCompanyName: params.personCompanyName,//工作单位全称
          personCompanyAddr: params.personCompanyAddr,
          personCompanyTime: params.personCompanyTime,
          personCompanyPost: params.personCompanyPost,
          personCompanyPhone: params.personCompanyPhone,
          personCompanyNature: params.personCompanyNature,
          personCompanyLinkman: params.personCompanyLinkman,
          personCompanyLinkmanPhone: params.personCompanyLinkmanPhone,
          personYearIncome: params.personYearIncome,
          personCompanyAge: params.personCompanyAge,
          personSocialSecurityTime: params.personSocialSecurityTime
      }).then((res) => {
        if (Number(res.data.code) === 0) {
         //保存成功
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: res.data.result || '个人信息保存失败'
          })
        }
        return res
      })
    },
    //个人信息初始化数据
    [types.GET_PERSONAL_INIT_DATA] ({dispatch, commit}, params) {
      return api.getPersonalInitData({
        token: params.token,
        customerId: params.customerId
      }).then((res) => {
        if (Number(res.data.rspcode) === 1) {

        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: res.result || '个人信息获取失败'
          })
        }
        return res
      })
    },
    [types.GET_ENTERPRISE_INFO] ({dispatch, commit}, params) {
      return api.getEnterpriseInfo({
        token: params.token,
        customerId: params.customerId
      }).then((res) => {
        const resData = res.data
        const result = resData.crmCustomerEnterprise
        if (Number(resData.code) === 0) {
          commit(types.SET_ENTERPRISE_INFO, {
            customerId: result.customerId,
            customerName: resData.customerName,
            enterpriseNumber: result.enterpriseNumber,
            enterprisePartnerNumber: result.enterprisePartnerNumber,
            enterpriseRegAddr: result.enterpriseRegAddr,
            enterpriseOfficeAddress: result.enterpriseOfficeAddress,
            enterpriseType: result.enterpriseType,
            enterpriseRegMoney: result.enterpriseRegMoney,
            enterpriseLegalUser: result.enterpriseLegalUser,
            enterpriseLegalUserPhone: result.enterpriseLegalUserPhone,
            enterpriseOrganizingNumber: result.enterpriseOrganizingNumber,
            enterpriseScale: result.enterpriseScale,
            enterpriseNationalNumber: result.enterpriseNationalNumber,
            enterpriseGovernmentNumber: result.enterpriseGovernmentNumber,
            enterpriseRegOrgan: result.enterpriseRegOrgan,
            enterpriseEmployeeNum: result.enterpriseEmployeeNum,
            enterpriseScope: result.enterpriseScope,
            enterpriseFoundExplain: result.enterpriseFoundExplain,
            isEditable: result.isEditable === '0',
            agrent:resData.agrent,
            agentIdNo:resData.agentIdNo,
            agentContact:resData.agentContact
          })
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '企业信息获取失败'
          })
        }
        return res
      })
    },
    [types.SAVE_ENTERPRISE_INFO] ({dispatch, commit}, params) {
      return api.saveEnterpriseInfo({
        token: params.token,
        customerId: params.customerId,
        customerName: params.customerName,
        enterpriseNumber: params.enterpriseNumber,
        enterprisePartnerNumber: params.enterprisePartnerNumber,
        enterpriseRegAddr: params.enterpriseRegAddr,
        enterpriseOfficeAddress: params.enterpriseOfficeAddress,
        enterpriseType: params.enterpriseType,
        enterpriseRegMoney: params.enterpriseRegMoney,
        enterpriseLegalUser: params.enterpriseLegalUser,
        enterpriseLegalIdNo: params.enterpriseLegalIdNo,
        enterpriseLegalUserPhone: params.enterpriseLegalUserPhone,
        enterpriseOrganizingNumber: params.enterpriseOrganizingNumber,
        enterpriseScale: params.enterpriseScale,
        enterpriseNationalNumber: params.enterpriseNationalNumber,
        enterpriseGovernmentNumber: params.enterpriseGovernmentNumber,
        enterpriseRegOrgan: params.enterpriseRegOrgan,
        enterpriseEmployeeNum: params.enterpriseEmployeeNum,
        enterpriseScope: params.enterpriseScope,
        enterpriseFoundExplain: params.enterpriseFoundExplain,
        userType: params.userType,
        registrationType: params.registrationType,
        province: params.province,
        city: params.city,
        enterpriseIndustry: params.enterpriseIndustry
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          commit(types.SET_ENTERPRISE_INFO, {
            customerName: params.customerName,
            enterpriseNumber: params.enterpriseNumber,
            enterprisePartnerNumber: params.enterprisePartnerNumber,
            enterpriseRegAddr: params.enterpriseRegAddr,
            enterpriseOfficeAddress: params.enterpriseOfficeAddress,
            enterpriseType: params.enterpriseType,
            enterpriseRegMoney: params.enterpriseRegMoney,
            enterpriseLegalUser: params.enterpriseLegalUser,
            enterpriseLegalUserPhone: params.enterpriseLegalUserPhone,
            enterpriseOrganizingNumber: params.enterpriseOrganizingNumber,
            enterpriseScale: params.enterpriseScale,
            enterpriseNationalNumber: params.enterpriseNationalNumber,
            enterpriseGovernmentNumber: params.enterpriseGovernmentNumber,
            enterpriseRegOrgan: params.enterpriseRegOrgan,
            enterpriseEmployeeNum: params.enterpriseEmployeeNum,
            enterpriseScope: params.enterpriseScope,
            enterpriseFoundExplain: params.enterpriseFoundExplain,
            userType: params.userType,
            registrationType: params.registrationType,
            province: params.province,
            city: params.city,
            enterpriseIndustry: params.enterpriseIndustry
          })
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '企业信息保存失败'
          })
        }
        return res
      })
    }
  },
  mutations: {
    [types.SET_ENTERPRISE_INFO] (state, data) {
      state.enterpriseInfo = {
        customerId: _.isEmpty(data.customerId) ? state.enterpriseInfo.customerId : data.customerId,
        customerName: _.isEmpty(data.customerName) ? state.enterpriseInfo.customerName : data.customerName,
        enterpriseNumber: _.isEmpty(data.enterpriseNumber) ? state.enterpriseInfo.enterpriseNumber : data.enterpriseNumber,
        enterprisePartnerNumber: data.enterprisePartnerNumber,
        enterpriseRegAddr: _.isEmpty(data.enterpriseRegAddr) ? state.enterpriseInfo.enterpriseRegAddr : data.enterpriseRegAddr,
        enterpriseOfficeAddress: _.isEmpty(data.enterpriseOfficeAddress) ? state.enterpriseInfo.enterpriseOfficeAddress : data.enterpriseOfficeAddress,
        enterpriseType: _.isEmpty(data.enterpriseType) ? state.enterpriseInfo.enterpriseType : data.enterpriseType,
        enterpriseRegMoney: data.enterpriseRegMoney,
        enterpriseLegalUser: _.isEmpty(data.enterpriseLegalUser) ? state.enterpriseInfo.enterpriseLegalUser : data.enterpriseLegalUser,
        enterpriseLegalUserPhone: _.isEmpty(data.enterpriseLegalUserPhone) ? state.enterpriseInfo.enterpriseLegalUserPhone : data.enterpriseLegalUserPhone,
        enterpriseOrganizingNumber: _.isEmpty(data.enterpriseOrganizingNumber) ? state.enterpriseInfo.enterpriseOrganizingNumber : data.enterpriseOrganizingNumber,
        enterpriseScale: _.isEmpty(data.enterpriseScale) ? state.enterpriseInfo.enterpriseScale : data.enterpriseScale,
        enterpriseNationalNumber: _.isEmpty(data.enterpriseNationalNumber) ? state.enterpriseInfo.enterpriseNationalNumber : data.enterpriseNationalNumber,
        enterpriseGovernmentNumber: _.isEmpty(data.enterpriseGovernmentNumber) ? state.enterpriseInfo.enterpriseGovernmentNumber : data.enterpriseGovernmentNumber,
        enterpriseRegOrgan: _.isEmpty(data.enterpriseRegOrgan) ? state.enterpriseInfo.enterpriseRegOrgan : data.enterpriseRegOrgan,
        enterpriseEmployeeNum: _.isEmpty(data.enterpriseEmployeeNum) ? state.enterpriseInfo.enterpriseEmployeeNum : data.enterpriseEmployeeNum,
        enterpriseScope: _.isEmpty(data.enterpriseScope) ? state.enterpriseInfo.enterpriseScope : data.enterpriseScope,
        enterpriseFoundExplain: _.isEmpty(data.enterpriseFoundExplain) ? state.enterpriseInfo.enterpriseFoundExplain : data.enterpriseFoundExplain,
        isEditable: _.isBoolean(data.isEditable) ? state.enterpriseInfo.isEditable : data.isEditable,
        userType: _.isEmpty(data.userType) ? state.enterpriseInfo.userType : data.userType,
        registrationType: _.isEmpty(data.registrationType) ? state.enterpriseInfo.registrationType : data.registrationType
      }
    },
    [types.SET_PERSONAL_INFO] (state, data) {
      state.myInfo = {
        customerId: _.isEmpty(data.customerId) ? state.myInfo.customerId : data.customerId,
        customerName: _.isEmpty(data.customerName) ? state.myInfo.customerName : data.customerName,
        personIdentityCard: _.isEmpty(data.personIdentityCard) ? state.myInfo.personIdentityCard : data.personIdentityCard,
        personMobile: _.isEmpty(data.personMobile) ? state.myInfo.personMobile : data.personMobile,
        isEditable: _.isEmpty(data.isEditable) ? state.myInfo.isEditable : data.isEditable
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/personalCenter/myInfo.js